import { CustomModelAutomaticMutationSideEffectConfigs } from "../types";

export const PORTAL_BRANDINGS_MUTATION_SIDE_EFFECT_CONFIGS: CustomModelAutomaticMutationSideEffectConfigs<"portal_brandings"> =
  {};
